import React from "react";
import { AppService, DomainTypes } from "../DomainTypes";

/** Loads an image from the images api client. */
export default class AsyncImageComponent extends React.Component<{ fileDescriptorId: number | null, maxHeight?: string } & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> {

    private src = "";
    private loadedDescriptor: number | null = null;
    private imagesApiClient = AppService.get(DomainTypes.ApiClients.ImagesApiClient);

    componentDidMount() {
        this.loadImage();
    }

    componentDidUpdate() {
        this.loadImage();
    }

    private async loadImage() {
        if (this.loadedDescriptor !== this.props.fileDescriptorId) {
            this.loadedDescriptor = this.props.fileDescriptorId;
            this.src = "";
            this.forceUpdate();

            if (this.props.fileDescriptorId) {
                const response = await this.imagesApiClient.getImageUrl(this.props.fileDescriptorId);
                this.src = response.data;
                this.forceUpdate();
            }
        }
    }

    public render() {
        const { fileDescriptorId, maxHeight, ...props } = this.props;

        return (
            <div {...props}>
                {fileDescriptorId && !this.src && <span>Loading image...</span>}
                {this.src && <img src={this.src} style={{ maxHeight: maxHeight }} />}
            </div>)
    }
}